import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en.json';
import hn from './hn.json';
import es from './es.json';
import ta from './ta.json';
import ml from './ml.json';
import te from './te.json';
import kn from './kn.json';
import tcy from './tcy.json';

i18n.use(LanguageDetector).init({
  interpolation: {
    escapeValue: false,
  },
  resources: { en, hn, es, ta, ml, te, kn, tcy },
  fallbackLng: 'en',
  react: {
    useSuspense: false,
  },
});

export const translate = (keys) => {
  return (value, options = {}) => {
    return i18n.t(value, { ns: [...keys], ...options }) || value;
  };
};

export default i18n;
